const en = {
  // GetHelp Section
  getHelp: {
    title: 'Get Help & Support',
    subtitle: 'Need assistance? Our team is here to help you. Reach out via phone, email, or live chat, or browse our FAQs below.',
    contactInfo: 'Contact Information',
    faq: 'Frequently Asked Questions',
    faqSubtitle: 'Find answers to common questions',
    emergency: 'Emergency',
    emergencyDesc: 'For immediate safety concerns',
    support: 'Support',
    supportDesc: 'General questions and assistance',
    technical: 'Technical',
    technicalDesc: 'App and website issues',
    phone: 'Phone',
    email: 'Email',
    chat: 'Live Chat',
    available: 'Available 24/7',
    responseTime: 'Response within 2 hours',
    responseTimeLong: 'Response within 24 hours',
  },
  // MyIssues Section
  myIssues: {
    title: 'My Issues & Complaints',
    subtitle: 'Track the status of your reported issues and complaints. For urgent help, please use the Get Help section.',
    noIssues: 'No complaints or issues found.',
    noIssuesDesc: 'If you need help, please use the Get Help section or report a new issue.',
    issueId: 'Issue ID',
    priority: 'Priority',
    status: 'Status',
    subject: 'Subject',
    type: 'Type',
    filedOn: 'Filed on',
    inProgress: 'In Progress',
    resolved: 'Resolved',
    closed: 'Closed',
    high: 'HIGH',
    medium: 'MEDIUM',
    low: 'LOW',
    loading: 'Loading...',
    error: 'Error loading issues',
  },
  // ReportIssue Section
  reportIssue: {
    title: 'Report an Issue',
    subtitle: 'Facing a problem? Please fill out the form below and our support team will get back to you within 24-48 hours.',
    selectOption: 'Select an option',
    selectIssueType: 'Select issue type',
    selectUrgency: 'Select urgency',
    beforeSubmit: 'Before you submit:',
    beforeSubmitPoints: [
      'For immediate safety concerns, please call emergency services',
      'Keep your ride receipt and any relevant screenshots',
      'We\'ll respond within 24-48 hours'
    ],
    submitIssue: 'Submit Issue Report',
    submitting: 'Submitting...',
    success: 'Your issue has been submitted successfully! Our support team will address it shortly.',
    error: 'Something went wrong. Please try again later.',
    loading: 'Loading...',
  },
  // Common
  common: {
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    submit: 'Submit',
    cancel: 'Cancel',
    back: 'Back',
    next: 'Next',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    close: 'Close',
    open: 'Open',
    yes: 'Yes',
    no: 'No',
    required: 'Required',
    optional: 'Optional',
  },
  aboutYou: {
    basicInfo: "Basic Information",
    firstName: "First Name",
    lastName: "Last Name",
    gender: "Gender",
    male: "Male",
    female: "Female",
    other: "Other",
    preferNotToSay: "Prefer not to say",
    dateOfBirth: "Date of Birth",
    contactInfo: "Contact Information",
    email: "Email Address",
    phoneNumber: "Phone Number",
    addressInfo: "Address Information",
    address: "Address",
    city: "City",
    state: "State",
    pincode: "PIN Code",
    emergencyContact: "Emergency Contact",
    emergencyContactNumber: "Contact Number",
    relationship: "Relationship",
    selectRelationship: "Select relationship",
    parent: "Parent",
    spouse: "Spouse",
    saveProfile: "Save Profile Information",
    edit:"Edit",
    phFirstName: "Enter first name",
    phLastName: "Enter last name",
    phEmail: "Enter email address",
    phPhone: "Enter phone number",
    phAddress: "Enter your address",
    phCity: "Enter city",
    phState: "Enter state",
    phPincode: "Enter PIN code",
    phEmergencyContact: "Enter emergency contact number",
    save: 'Save',
    firstNameRequired: 'First name is required.',
    firstNameInvalid: 'First name must contain only letters, spaces, apostrophes, or hyphens.',
    lastNameRequired: 'Last name is required.',
    lastNameInvalid: 'Last name must contain only letters, spaces, apostrophes, or hyphens.',
    emailRequired: 'Email is required.',
    emailInvalid: 'Please enter a valid email address.',
    phoneRequired: 'Phone number is required.',
    phoneInvalid: 'Phone number must be 10 to 15 digits.',
    dobRequired: 'Date of birth is required.',
    dobInvalid: 'Please enter a valid date of birth (YYYY-MM-DD).',
    genderRequired: 'Gender is required.',
    addressRequired: 'Address is required.',
    cityRequired: 'City is required.',
    cityInvalid: 'City must contain only letters, spaces, apostrophes, or hyphens.',
    stateRequired: 'State is required.',
    stateInvalid: 'State must contain only letters, spaces, apostrophes, or hyphens.',
    countryRequired: 'Country is required.',
    countryInvalid: 'Country must contain only letters, spaces, apostrophes, or hyphens.',
    pincodeRequired: 'Pincode is required.',
    pincodeInvalid: 'Pincode must be 4 to 10 digits.',
    emergencyContactRequired: 'Emergency contact number is required.',
    emergencyContactInvalid: 'Emergency contact number must be 10 digits.',
    relationshipRequired: 'Relationship is required.',
    relationshipInvalid: 'Please select a valid relationship for emergency contact.',
    emergencyCountryCodeRequired: 'Emergency country code is required.',
    fixErrorsBeforeSaving: 'Please review the highlighted fields and correct any errors before saving your profile.',
  },
  account: {
    goodMorning: "Good Morning",
    goodAfternoon: "Good Afternoon",
    goodEvening: "Good Evening",
    completeIdentity: "Complete your identity verification",
    addEmergencyContact: "Add emergency contact information",
    uploadDriverLicense: "Upload driver license for rider profile",
    aboutYou: "About You",
    aboutYouDesc: "Tell us about yourself",
    identityVerification: "Identity Verification",
    identityVerificationDesc: "Verify your identity",
    offerRides: "Offer Rides",
    offerRidesDesc: "Set up your driver profile",
    findRides: "Find Rides",
    findRidesDesc: "Your travel preferences",
    appSettings: "App Settings",
    appSettingsDesc: "Customize your experience",
    walletPayments: "Wallet & Payments",
    walletPaymentsDesc: "Manage your money",
    referralProgram: "Referral Program",
    referralProgramDesc: "Earn rewards by referring friends",
    supportGrievances: "Support & Grievances",
    supportGrievancesDesc: "Get help or file complaints",
    actionRequired: "Action Required",
    completeProfile: "Complete Your Profile",
    profileHelp: "Help our AI find the perfect rides for you by completing your profile!",
  },
  settings: {
    appSettings: 'App Settings',
    appSettingsDesc: 'Customize your Duri  experience and manage your privacy preferences.',
    languageRegion: 'Language & Region',
    languagePrompt: 'Which language would you prefer?',
    timezone: 'Timezone',
    currency: 'Currency',
    appPermissions: 'App Permissions',
    appPermissionsDesc: 'These permissions help us provide you with the best ride experience. You can change these anytime.',
    locationAccess: 'Location Access',
    locationAccessDesc: 'Let us show nearby rides and provide navigation',
    readSmsOtp: 'Read SMS/OTP',
    readSmsOtpDesc: 'Auto-fill OTP codes for faster verification',
    phoneCalls: 'Phone Calls',
    phoneCallsDesc: 'Allow calling riders/travelers for coordination',
    notifications: 'Notifications',
    notificationsDesc: 'Choose how you want to stay updated about your rides and Duri  news.',
    pushNotifications: 'Push Notifications',
    pushNotificationsDesc: 'Ride updates, messages, and important alerts',
    emailNotifications: 'Email Notifications',
    emailNotificationsDesc: 'Ride confirmations and receipts via email',
    smsNotifications: 'SMS Notifications',
    smsNotificationsDesc: 'Critical ride updates via text message',
    rideReminders: 'Ride Reminders',
    rideRemindersDesc: 'Reminders about upcoming rides',
    promotionalUpdates: 'Promotional Updates',
    promotionalUpdatesDesc: 'Special offers and new features',
    saveSettings: 'Save Settings',
  },
  header: {
    home: 'Home',
    findRide: 'Find Ride',
    offerRide: 'Offer Ride',
    manageRides: 'Manage Rides',
    account: 'Account',
    logout: 'Logout',
    aiAssistant: 'Duri  AI Assistant',
    findPerfectRideMatch: 'Find your perfect ride match',
    connectWithTravelers: 'Connect with travelers on your route',
    askAiFindingRides: 'Ask AI about finding rides...',
    askAiOfferingRides: 'Ask AI about offering rides...',
    findRidesToBandra: 'Find rides to Bandra',
    cheapestRouteToAirport: 'Cheapest route to airport',
    dailyCommuteToPowai: 'Daily commute to Powai',
    postRideToGurgaon: 'Post ride to Gurgaon',
    setRecurringRoute: 'Set recurring route',
    managePassengers: 'Manage passengers',
    // Added for landing page header
    benefits: 'Benefits',
    howItWorks: 'How Duri Works ',
    findARide: 'Find a Ride',
    safety: 'Safety',
    support: 'Support',
    waitingGuests: 'Ride Requests',
    availableRides: 'Available Rides',
    commuteCarpool: 'Commute Carpool',
    corporateCarpool: 'Corporate Carpool',
    dailyCommutes: 'Daily Commute Carpool',
    popularRoutes: 'Popular Rides',
    faqs: 'FAQs',
    login: 'Login',
    getStarted: 'Get Started',
    downloadApp: 'Download App',
  },
  appStore: {
    title: 'Get Our Mobile App',
    description: 'Experience the best ride-sharing on the go. Download now for live tracking, instant notifications, and seamless booking.',
    getItOn: 'DOWNLOAD IN',
    googlePlay: 'Google Play',
    downloadOnThe: 'DOWNLOAD IN',
    appStore: 'App Store',
    thanksForJoining: 'Thank you for joining our daily commute carpool and ride-sharing network.!',
    communityMessage1: 'Experience the future of ride sharing',
    communityMessage2: 'Download our app and join thousands of travelers',
    ctaMessage: 'Available on iOS and Android • Free to download',
    featuresTitle: 'Plan today, Enjoy every celebration',
    featuresSubtitle: 'A safe & secure ride through verified guests and hosts',
    liveTrackingTitle: 'City to City Rides',
    liveTrackingDesc: 'Track your ride in real-time with GPS.',
    sosSupportTitle: 'Share Cost',
    sosSupportDesc: '24/7 emergency support at your fingertips.',
    perSeatPriceTitle: 'Per Seat Booking',
    perSeatPriceDesc: 'Pay only for your seat. Transparent pricing.',
    privatevehicle: 'Private Vehicle',
    privatevehicleDesc: 'Travel in your own car with your own driver.',
    dailyCommuteCarpoolTitle: 'Daily Commute Carpool',
    dailyCommuteCarpoolDesc: 'Share weekday office rides with verified co-travellers.',
    verifiedCommunityTitle: 'Verified Community',
    verifiedCommunityDesc: 'Travel with verified hosts and guests. Our safety-first approach ensures peace of mind on every journey.',
    anytimeRidesTitle: 'Rides Anytime',
    anytimeRidesDesc: 'Find rides 24/7. Whether it\'s early morning or late night, connect with travelers going your way.',
    instantBookingTitle: 'Instant Booking',
    instantBookingDesc: 'Book your ride in seconds. Quick confirmation and seamless payment process for hassle-free travel.',
    firstRideOfferBadge: '50% OFF',
    firstRideOfferTitle: 'On Your First Ride!',
    firstRideOfferDesc: 'New to Duri? Get 50% off on your first ride!',
    referralRewardTitle: 'Earn Multiple Rewards!',
    referralRewardDesc: 'Get ₹125 for completing your onboarding and ₹100 for each successful referral. Start earning today!',
    onboardingRewardTitle: 'Onboarding Reward',
    onboardingRewardDesc: 'Earn ₹125 when you register, upload documents, get verified, and complete your first hosted ride with at least one guest.',
    referralProgramTitle: 'Referral Reward',
    referralProgramDesc: 'Earn ₹100 for each friend who installs the app, enters your number, uploads documents, gets verified, and completes their first hosted ride.',
    limitedTimeOffer: 'Limited Time Offer',
    noCodeNeeded: 'No Code Needed',
    applyAutomatically: 'Applies Automatically',
  },
  footer: {
    downloadAppTitle: 'Download Duri',
    downloadAppDesc: 'Get the mobile app for the best experience with live tracking, instant notifications, and seamless ride booking on the go. Available for free on all devices.',
    getItOn: 'Download in',
    googlePlay: 'Google Play',
    downloadOnThe: 'Download in',
    appStore: 'App Store',
    scanForAndroid: 'Scan for Android',
    scanForIOS: 'Scan for iOS',
    googlePlayStore: 'Google Play Store',
    appleAppStore: 'Apple App Store',
    brandDesc:
      'Smart commuting for everyday travelers. Save more, travel together and build better cities.',
    followUs: 'Follow us on',
    contactEmail: 'contact@hansaitechnosoft.com',
    contactPhone: '+91 76809 38741',
    contactHours: 'Available hrs: 8 AM to 10 PM IST',
    availableCountries: 'Available in 25+ countries',
    sectionCompany: 'Company',
    sectionGuests: 'For Guest',
    sectionHosts: 'For Hosts',
    sectionTravelers: 'For Travelers',
    sectionSupport: 'Help and Support',
    sectionLegal: 'Legal and Compliance',

    companyLinks: {
      aboutUs: 'About Us',
      news: 'News & Updates',
      howItWorks: 'How Duri Works',
      safety: 'Safety',
      duriGreenMobility: 'Duri Green Mobility',
    },
    guestLinks: {
      howToBook: 'How to book a Ride?',
      findARide: 'Find a Ride',
      availableRides: 'Available Rides',
      searchByRideId: 'Search Ride By Ride Id',
      searchByRider: 'Search Ride by Rider',
      howToBookGuide: 'How to book a Ride',
      howToDailyCommute: 'How to Daily Commute',
      commuteCalculator: 'Commute Calculator (Guest)',
    },
    hostLinks: {
      howToHost: 'How to Host a Ride?',
      rideRequests: 'Ride Requests',
      lookUpARide: 'Look up a Ride',
      howToDailyCommute: 'How to Daily Commute',
      popularRoutes: 'Popular Rides',
      commuteCalculator: 'Commute Calculator (Host)',
    },
    travelersLinks: {
      findRides: 'Book Ride',
      offerRides: 'Host Ride',
      safetyFirst: 'Safety',
      ridesharingImpact: 'Ridesharing Impact',
      mobileApp: 'Mobile App',
      referFriends: 'Refer Friends',
      helpCenter: 'Help Center'
    },
    supportLinks: {
      reportIssue: 'Report an Issue',
      myIssues: 'My support tickets',
      getHelp: 'Get Help',
      whatsappSupport: 'WhatsApp Support',
      corporateCarpool: 'Corporate Carpool',
    },
    legalLinks: {
      termsOfService: 'Terms and Conditions',
      privacyPolicy: 'Privacy Policy',
      cookiePolicy: 'Cookie Policy',
      refundPolicy: 'Cancellation Policy',
      deleteAccount: 'Account Deletion',
      tripInsurance: 'Trip Insurance',
      paymentTerms: 'Payment Terms and Conditions',
      communityGuidelines: 'Community Guidelines'
    },
    copyright: '© 2025 Duri. All rights reserved.',
    copyrightText: '© {year} HansAI Techno Soft Private Limited. All rights reserved.'
  },
  howItWorks: {
    sectionTitle: 'How Duri Works ',
    sectionSubtitle: 'Four simple steps as a Host to transform your travel experience.',
    searchTitle: 'List Your Ride',
    searchDesc: 'Offer your available seats and routes to guests in just a few clicks.',
    connectTitle: 'Connect',
    connectDesc: 'Communicate with guests to confirm bookings and ensure smooth travel plans.',
    payTitle: 'Earn',
    payDesc: 'Get paid securely for each shared ride while maximizing your vehicle’s usage.',
    travelTitle: 'Drive',
    travelDesc: 'Provide safe, reliable rides with features like real-time tracking and guest ratings.',
    GuestsectionSubtitle: 'Four simple steps as a Guest to transform your travel experience.',
    GuestsearchTitle:'Search',
    GuestsearchDesc:'Find rides offered by verified hosts that match your route and schedule effortlessly.',
    GuestconnectTitle:'Connect',
    GuestconnectDesc:'Chat directly with hosts to coordinate pickup points and travel details securely.',
    GuestpayTitle:'Pay',
    GuestpayDesc:'Book your ride and pay safely through our platform, splitting costs conveniently.',
    GuesttravelTitle:'Travel',
    GuesttraveDesc:'Enjoy a comfortable, safe journey with real-time tracking and ride support.'
  },
  safety: {
    badge: 'Your Safety First',
    sectionTitle: 'Trust through',
    sectionTitleHighlight: 'verified connections',
    sectionSubtitle: 'Every user is verified on our trusted ride sharing app to ensure safe travel, trustworthy, and compatible ride experiences.',
    idVerificationTitle: 'Government ID Verification',
    idVerificationDesc: 'All users must verify their identity with government-issued documents like Aadhaar, PAN, or Driving License',
    idVerificationStats: '100% ID verified users',
    professionalTitle: 'Professional Background',
    professionalDesc: 'We record and verify work history, company details, and professional references for complete transparency',
    professionalStats: '95% professionals verified',
    cultureTitle: 'Culture & Language Match',
    cultureDesc: 'Smart matching based on cultural preferences, languages spoken, and regional familiarity',
    cultureStats: '90% compatibility score',
    interestsTitle: 'Interests & Hobbies',
    interestsDesc: 'Connect with like-minded travelers who share similar interests and lifestyle preferences',
    interestsStats: '85% interest alignment',
    trackingTitle: 'Real-time Tracking',
    trackingDesc: 'Stay secure with real-time ride tracking and smart mobility solutions for every trip.',
    trackingStats: '24/7 safety monitoring',
    secureCommTitle: 'Secure Communication',
    secureCommDesc: 'Enjoy secure communication on our app for verified hosts and guests— privacy guaranteed.',
    secureCommStats: 'Bank-level encryption',
    backgroundVerified: 'Background Verified',
    safeRidesCompleted: 'Safe Rides Completed on ridesharing platform',
    trustScoreAverage: 'Trust Score Average',
    emergencyResponse: 'Emergency Response',
    ctaTitle: 'Ready to travel safely?',
    ctaDesc: 'Join our verified community and experience the safest way to share rides.',
    ctaButton: 'Start Verification Process',
  },
  hero: {
    badge: 'Trusted by guests & verified hosts on our platform',
    mainTitle: 'Share Ride Save',
    mainTitleHighlight: 'wallet and planet',
    subtitle: 'Join most trusted intercity ride sharing app — share your ride, save more, and travel smarter.',
    findRide: 'Book a ride',
    offerRide: 'Host a ride',
    statSaved: 'Ride Between Cities',
    statCO2: 'CO₂ tons reduced',
    statHappy: 'Happy rides',
    cityToCityRides: 'City to City Rides',
    rideBetweenCities: 'Ride Between Cities',
    shareCost: 'Share Cost',
    shareToSave: 'Share to Save',
    perSeatBooking: 'Per Seat Booking',
    reserveYourSeat: 'Reserve Your Seat',
    privateVehicles: 'Private Vehicles',
    privateComfortable: 'Private & Comfortable',
    dailyCommuteCarpool: 'Daily Commute Carpool',
  },
  statistics: {
    sectionTitle: 'RideSharing Impact',
    sectionSubtitle: 'Real numbers from real travelers making a real difference.',
    travelersLabel: 'Travelers',
    travelersDesc: 'Trust ridesharing worldwide',
    citiesLabel: 'Cities',
    citiesDesc: 'Connected globally',
    savedLabel: 'Saved',
    savedDesc: 'By ridesharing community',
    co2Label: 'Tons CO₂',
    co2Desc: 'Emissions saved — the ultimate carbon-saving travel solution',
    costReductionLabel: 'Cost Reduction',
    costReductionSuffix: '% vs solo travel',
    emissionReductionLabel: 'Emission Reduction',
    emissionReductionSuffix: '% vs individual cars',
    userSatisfactionLabel: 'User Satisfaction',
    userSatisfactionSuffix: '% would recommend',
    safetyRateLabel: 'Safety Rate',
    safetyRateSuffix: '% incident-free',
  },
  benefits: {
    badge: 'Why Duri?',
    sectionTitle: 'Everything you need',
    sectionSubtitle: 'For smarter, safer, and more sustainable travel.',
    saveMoneyTitle: 'Save Money',
    saveMoneyDesc: 'Enjoy budget travel with low-cost ride sharing options that reduce expenses by up to 70%',
    saveMoneyStats: 'Save ₹15,000 a Year with Ride Sharing',
    helpPlanetTitle: 'Help Planet',
    helpPlanetDesc: 'Choose a green travel solution and reduce CO₂ with every shared travel app ride',
    helpPlanetStats: '2.3 kg CO₂ saved per 100km',
    travelSafeTitle: 'Travel Safe',
    travelSafeDesc: 'A reliable carpool app with verified Hosts and real-time ride tracking',
    travelSafeStats: '99.8% incident-free rides',
    anyTimeTitle: 'Any Time',
    anyTimeDesc: 'Access city-to-city rides anytime with our real-time navigation app.',
    anyTimeStats: 'Available around the clock',
    meetPeopleTitle: 'Meet People',
    meetPeopleDesc: 'Connect and travel together through our growing ride sharing community',
    meetPeopleStats: '85% connected via ride sharing',
    goAnywhereTitle: 'Go Anywhere',
    goAnywhereDesc: 'Access to 500+ destinations across multiple countries',
    goAnywhereStats: '500+ cities worldwide',
  },
  testimonials: {
    sectionTitle: 'Stories from Our Community',
    sectionSubtitle: "Real experiences from real travelers who've discovered the joy of shared journeys.",
    averageRating: 'Average Rating',
    recommendUs: 'Recommend Us',
    happyTravelers: 'Happy Travelers',
    customerSupport: 'Customer Support',
    trustedBy: 'Trusted by Employees From',
    items: [
      JSON.stringify({
        name: 'Priya Sharma',
        role: 'Software Engineer',
        location: 'Mumbai → Pune Route',
        rating: 5,
        text: "I've saved over ₹8,000 in the last 6 months using RideSharing for my weekly Mumbai-Pune trips. The app is most reliable carpool app with verified hosts and simple booking.",
        avatar: '👩‍💼',
        savings: '₹8,000 saved'
      }),
      JSON.stringify({
        name: 'Raj Patel',
        role: 'Business Owner',
        location: 'Delhi → Jaipur Route',
        rating: 5,
        text: "As someone who travels to Jaipur twice a month for business, this platform has been a game-changer. Great company, reliable service, and I'm helping the environment too!",
        avatar: '👨‍💼',
        savings: '60% cost reduction'
      }),
      JSON.stringify({
        name: 'Anita Reddy',
        role: 'College Student',
        location: 'Bangalore → Chennai Route',
        rating: 5,
        text: "Perfect for students and professionals looking for a low-cost travel app to save daily commute costs. I can afford to go home more often now. The safety features give my parents peace of mind, and I've made some great friends along the way.",
        avatar: '👩‍🎓',
        savings: '₹12,000 annually'
      }),
      JSON.stringify({
        name: 'Vikram Singh',
        role: 'Marketing Manager',
        location: 'Hyderabad → Vijayawada Route',
        rating: 5,
        text: "The quality of co-passengers is excellent. Had meaningful conversations and even found business networking opportunities. It's not just about saving money anymore.",
        avatar: '👨‍💻',
        savings: 'New connections'
      })
    ]
  },
  quickRideFinder: {
    destinationPrompt: '🎯 Perfect! Where are we heading?',
    destinationSubPrompt: 'Type your destination or pick from popular choices below',
    destinationPlaceholder: 'e.g., Pune, Delhi, Bangalore...',
    nextWhen: 'Next: When? →',
    datePrompt: '📅 Great choice! {from} to {to}',
    dateSubPrompt: 'When would you like to travel?',
    nextPassengers: 'Next: How many passengers? →',
    passengersPrompt: '👥 Almost there! How many passengers?',
    passengersSubPrompt: 'Including yourself',
    perfectFindRides: "Perfect! Let's find rides →",
    readyTitle: '🎉 Ready to Search!',
    from: 'From:',
    to: 'To:',
    date: 'Date:',
    passengers: 'Passengers:',
    person: 'person',
    people: 'people',
    findMyPerfectRide: 'Find My Perfect Ride!',
    today: 'Today',
    tomorrow: 'Tomorrow',
    thisWeekend: 'This Weekend',
    locationNotFoundLabel: '📍 Location not found',
    locationNotFoundMessage: 'Please enable location access or enter your location manually to get started!',
  },
  topBar:{
  welcomeMessage: "Trusted ridesharing app for intercity travel, intracity trips, and daily commute carpool. ",
  },
};
export default en; 